import {
  OPEN_TWIN_COMPONENT
} from "../actions/digitaltwin";
import _ from "lodash";

export default function(state = [], action) {
  switch (action.type) {
    case OPEN_TWIN_COMPONENT:
      return action.payload;
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/reducers/twincmp.js